import Image from "next/image";

type SliderRowProps = {
  images: string[];
  direction: "ltr" | "rtl";
};

export const SliderRowH: React.FC<SliderRowProps> = ({ images, direction }) => {
  const animation =
    direction === "ltr" ? "animate-slide-ltr" : "animate-slide-rtl";

  return (
    <div className={`flex w-[200%] gap-8 ${animation}`}>
      {[...images, ...images].map((src, idx) => (
        <div
          key={idx}
          className="
            relative
            aspect-[10/16]
            h-[50vh] md:h-[45vh]
            shrink-0
            overflow-hidden
          "
        >
          <Image
            src={src}
            alt=""
            fill
            priority={idx < 4}
            sizes="(min-width: 1024px) 18vw, (min-width: 768px) 22vw, 40vw"
            className="object-cover"
          />
        </div>
      ))}
    </div>
  );
};
